// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e5a34848","513":"0fe26f93","703":"fe62bfb8","787":"a022b306"}[chunkId] + ".chunk.js";
};